import { useAtom } from "jotai"
import { userAtom } from "../store"
import { useEffect } from "react";

export default function ProfileTitle() {
    const [userData] = useAtom(userAtom)

    if(!userData){
        return <div/>
    }

    return (
        <div className="flex max-sm:flex-col gap-y-5 justify-between sm:items-center mb-10">
            <h1 className="page-title !mb-0">
                My Profile
            </h1>

            <div className="flex gap-x-2 flex-wrap gap-y-4">

                <div className="text-white text-sm bg-gray px-5 py-[10px] rounded-[32px]">
                    $ {(userData?.balance - userData?.pendingBalance).toFixed(2)} &nbsp;
                    <span className="text-primary">
                        Withdrawable
                    </span>
                </div>
                <div className="text-white text-sm bg-gray px-5 py-[10px] rounded-[32px]">
                    $ {userData?.balance?.toFixed(2)} &nbsp;
                    <span className="text-primary">
                        Total Balance
                    </span>
                </div>

                <div className="text-white text-sm bg-gray px-5 py-[10px] rounded-[32px]">
                    {userData.monthly_sales || 0} &nbsp;
                    <span className="text-primary">
                        Sales This Month
                    </span>
                </div>
            </div>
        </div>
    )
}